import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import {
  MenuList,
  MenuItem,
  Chip,
  IconButton,
  LinearProgress,
  Divider,
  Popper,
  Paper,
  DialogContent,
  Checkbox
} from "@material-ui/core";
import { AppContext } from "../App";
import CloseIcon from "@material-ui/icons/CloseOutlined";
import { clearWord } from "../AppClass";
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import MyAutoSuggest from "./MyAutoSuggest";
import { FormControlLabel } from "@material-ui/core/es";

const styles = theme => ({
  typography: {
    margin: theme.spacing(2)
  }
});

class SimplePopover extends React.Component {
  state = {
    anchorEl: null,
    wordCorrect: false
  };

  //unused
  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  //unused
  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <AppContext.Consumer>
        {({ state, actions }) => (
          <div>
            {/* <Button
              aria-owns={open ? "simple-popper" : undefined}
              aria-haspopup="true"
              variant="contained"
              onClick={this.handleClick}
            >
              Open Popover
            </Button>
            <button onClick={actions.hideSuggest}>
              {state.inputText} WordSuggest.js
            </button> */}

            <div className={"noselect selectedWord"}>
              <b>{clearWord(state.clickedWord)}</b>
            </div>

            <Divider />

            {state.suggestedWords.length > 0 && (
              <div className={"similarWords"}>
                {/*<Typography className={"noselect"}>Suggestions</Typography>*/}
                {state.suggestedWords.map(word => {
                  return (
                    <Chip
                      key={word}
                      label={word}
                      clickable
                      variant={"outlined"}
                      className="wordSuggestion"
                      //onClick={() => {actions.pickWord(word)}}
                    />
                    //<span
                    //  className="greenClass"
                    //  key={word}>
                    //      {word}
                    // </span>
                  );
                })}
              </div>
            )}

            {state.suggestedWords.length < 1 && (
              <div className={"similarWords"}>
                <Typography className={"noselect"}>
                  No suggestions.
                  <br />
                  Try searching
                </Typography>
              </div>
            )}
            <Divider />

            <div className={"wordCorrectClass"}>
              <Button size="small" color="primary" id="add2dict">
                Add to dictionary
              </Button>

              {/* <FormControlLabel
                control={
                  <Checkbox
                    //checked={this.state.wordCorrect}
                    //onChange={() => {alert('change')}}
                    onClick={() => {
                      alert("click");
                      //this.setState({ wordCorrect: true });
                    }}
                    value="correct"
                  />
                }
                label="Add to dictionary"
                labelPlacement="start"
              /> */}
            </div>

            {/*<MyAutoSuggest />*/}

            {state.suggestLoading && <LinearProgress />}

            {/*<Popper*/}
            {/*className={"index-z"}*/}
            {/*id={"myid"}*/}
            {/*//open={state.openSuggest}*/}
            {/*open={false}*/}
            {/*anchorEl={state.suggestAnchor}*/}
            {/*placement={"bottom-start"}*/}
            {/*disablePortal={true}*/}
            {/*modifiers={{*/}
            {/*flip: {*/}
            {/*enabled: false*/}
            {/*},*/}
            {/*arrow: {*/}
            {/*enabled: false,*/}
            {/*element: state.suggestAnchor*/}
            {/*},*/}
            {/*preventOverflow: {*/}
            {/*enabled: "enabled",*/}
            {/*boundariesElement: "scrollParent" //'viewport'*/}
            {/*}*/}
            {/*}}*/}
            {/*>*/}
            {/*<Paper>*/}
            {/*<Typography*/}
            {/*className={"selectedWord noselect"}*/}
            {/*variant={"h6"}*/}
            {/*color="secondary"*/}
            {/*>*/}
            {/*{clearWord(state.clickedWord)}*/}
            {/*<IconButton aria-label="Close" onClick={actions.hideSuggest}>*/}
            {/*<CloseIcon fontSize="small" />*/}
            {/*</IconButton>*/}
            {/*</Typography>*/}

            {/*{state.suggestedWords.length > 0 && (*/}
            {/*<div className={"similarWords"}>*/}
            {/*<Typography className={"noselect"}>Suggestions</Typography>*/}

            {/*{state.suggestedWords.map(word => {*/}
            {/*return (*/}
            {/*<Chip*/}
            {/*key={word}*/}
            {/*label={word}*/}
            {/*variant="outlined"*/}
            {/*className="marginRight10 marginTop10"*/}
            {/*onClick={() => actions.pickWord(word)}*/}
            {/*/>*/}
            {/*);*/}
            {/*})}*/}
            {/*</div>*/}
            {/*)}*/}
            {/*{state.suggestLoading && <LinearProgress />}*/}
            {/*</Paper>*/}
            {/*</Popper>*/}

            {/*<Popover*/}
            {/*id="simple-popper"*/}
            {/*// open={open}*/}
            {/*//open={state.openSuggest}*/}
            {/*open={false}*/}
            {/*//anchorEl={anchorEl}*/}
            {/*anchorEl={state.suggestAnchor}*/}
            {/*//onClose={this.handleClose}*/}
            {/*onClose={actions.hideSuggest}*/}
            {/*anchorOrigin={{*/}
            {/*vertical: "bottom",*/}
            {/*horizontal: "left"*/}
            {/*}}*/}
            {/*transformOrigin={{*/}
            {/*vertical: "top",*/}
            {/*horizontal: "left"*/}
            {/*}}*/}
            {/*>*/}
            {/*<Typography*/}
            {/*className={"selectedWord noselect"}*/}
            {/*variant={"h6"}*/}
            {/*color="secondary"*/}
            {/*>*/}
            {/*{state.clickedWord}*/}
            {/*</Typography>*/}

            {/*{state.suggestedWords.length > 0 && (*/}
            {/*<div className={"similarWords"}>*/}
            {/*<Typography className={"noselect"}>Suggestions</Typography>*/}

            {/*{state.suggestedWords.map(word => {*/}
            {/*return (*/}
            {/*<Chip*/}
            {/*key={word}*/}
            {/*label={word}*/}
            {/*variant="outlined"*/}
            {/*className="marginRight10 marginTop10"*/}
            {/*onClick={() => actions.pickWord(word)}*/}
            {/*/>*/}
            {/*);*/}
            {/*})}*/}
            {/*</div>*/}
            {/*)}*/}

            {/*<MenuList>*/}
            {/*/!* <Divider />*/}
            {/*<MenuItem onClick={() => actions.pickWord(state.clickedWord + "wordpicked")}>*/}
            {/*Auto correct*/}
            {/*</MenuItem>*/}
            {/*<MenuItem onClick={actions.hideSuggest}>*/}
            {/*Meaning*/}
            {/*</MenuItem>*/}
            {/*<Typography className={"selectedWord noselect"} variant={"overline"}>This is the meaning of the word.</Typography>*/}
            {/**!/*/}

            {/*<MenuItem onClick={actions.hideSuggest}>*/}
            {/*/!* <IconButton><CloseIcon /></IconButton>          *!/*/}
            {/*<CloseIcon />*/}
            {/*</MenuItem>*/}
            {/*</MenuList>*/}
            {/*{state.suggestLoading && <LinearProgress />}*/}
            {/*</Popover>*/}
          </div>
        )}
      </AppContext.Consumer>
    );
  }
}

SimplePopover.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimplePopover);
